import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './App.css';
import 'antd/dist/antd.css';

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js